import type { SalaryWorkTimeNode } from '@/modules/companies'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Field } from '@/components/ui'
import { SalarySettingCombobox } from '@/components/combobox/salary-setting-combobox'
import { PERMISSIONS, usePermissions } from '@/utils'

export type IdFilterInput = {
  id: string
}

interface SalarySettingSelectProps {
  alwaysInclude?: SalaryWorkTimeNode
  setOnLoad?: boolean
  value: string | null
  disabled?: boolean
  placeholder?: string
  className?: string
  onChange(value: string | null): void
}

export const SalarySettingSelect: React.FC<SalarySettingSelectProps> = ({
  value,
  disabled = false,
  placeholder,
  className,
  onChange,
}) => {
  const translations = useTranslate({
    placeholder: 'common.standard-for-user',
  })
  const { hasPermissions } = usePermissions()

  const canChangeSalaryMode = hasPermissions(
    PERMISSIONS.salary.change.salarySetting
  )
  const form = useForm<IdFilterInput>({
    defaultValues: { id: value ?? '' },
  })

  return (
    <div className="mb-2">
      <Controller
        control={form.control}
        name="id"
        render={({ field }) => (
          <Field>
            <SalarySettingCombobox
              {...field}
              mode="single"
              clearable={true}
              className={className}
              placeholder={placeholder ?? translations.placeholder}
              disabled={disabled || !canChangeSalaryMode}
              onChange={value => {
                onChange(value ?? null)
                form.setValue('id', value)
              }}
            />
          </Field>
        )}
      />
    </div>
  )
}
